<template>
  <div>
      <el-form :inline="true" :model="searchForm">
            <el-form-item label="ICCID号：">
                <el-input v-model.trim="searchForm.iccid"  @keyup.enter.native="getUseDataHanler" clearable></el-input>
            </el-form-item>
            <el-form-item label="套餐开始/结束时间：" class="dateRange">
                <el-date-picker v-model="searchForm.time" range-separator="至" type="daterange" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
             <el-form-item label="供应商名称："> 
                <el-select v-model="searchForm.supplierCode" clearable filterable>
                    <el-option v-for="item in branchSupplierOption" :value="item.id" :key="item.id" :label="item.name + '(' + item.alias + ')'"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item class="btnArea">
                <el-button type="primary" plain @click="getUseDataHanler" icon="el-icon-search">搜索查询</el-button>
                <el-button type="success" plain @click="exportConsumption"   icon="el-icon-download">导出</el-button>
            </el-form-item>
            <div>
                <p style="color:red;margin-bottom: 20px;">备注：1：套餐开始时间默认搜索本月生效。</p>
            </div>
        </el-form>

        <el-table :data="tbpg.tableData" 
		border
		fit
		highlight-current-row
		style="width: 100%;"
		:header-cell-style="{background:'#f5f5f5'}"
		>
            <el-table-column type="index" label="序号" align="center"></el-table-column>
            <el-table-column label="ICCID号" width="180px" align="center">
                <template slot-scope="scope">
                    <a href="javascript:void(0)" @click="goToDetailPage(scope.row)">{{ scope.row.iccid }}</a>
                </template>
            </el-table-column>
            <el-table-column  label="消费金额" show-overflow-tooltip align="center">
                <template slot-scope="scope">
                    <span>{{ scope.row.orderPrice}}</span>
                </template>
            </el-table-column>
            <el-table-column  label="佣金" show-overflow-tooltip align="center">
                <template slot-scope="scope">
                    <span>{{ scope.row.commission}}</span>
                </template>
            </el-table-column>
            <el-table-column  label="已使用流量(G)" show-overflow-tooltip align="center">
                <template slot-scope="scope">
                    <span>{{ scope.row.useData}}</span>
                </template>
            </el-table-column>
            <el-table-column  label="运营商名称" show-overflow-tooltip align="center">
                <template slot-scope="scope">
                    <span>>{{ scope.row.supplierName}}</span>
                </template>
            </el-table-column>
        </el-table>  
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tbpg.currentPage"
            :page-sizes="[15, 50, 100, 500]"
            :page-size="tbpg.pageSize"
			background
            layout="total, sizes, prev, pager, next, jumper"
            :total="tbpg.total">
        </el-pagination>
  </div>
 
</template>

<script>
import {getUseData,exportConsumptionList} from '@/api/sim.js'
import common from '@/utils/common.js'
export default {
    data() {
        return {
            searchForm: {
                iccid: null,
                usedFlowRate: null,
                time: '',
                supplierCode:null
            },
            tbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0
            },
            branchSupplierOption: [],
        }
    },
    methods: {
        getUseDataHanler($event){
            common.resetCurrentPage(this, $event, 'tbpg');
            var data = common.getRequestParams(this, 'tbpg', this.searchForm);
            if(data.usedFlowRate){
                data.usedFlowRate = data.usedFlowRate * 1024;
            }
            getUseData(data).then(res => {
                common.listCallback(this, res, 'tbpg');
            })
        },
        handleSizeChange(val){
            this.tbpg.pageSize = val;
            this.getUseDataHanler();
        },
        handleCurrentChange(val){
            this.tbpg.currentPage = val;
            this.getUseDataHanler();
        },
        getMonthFirstDay(){   
            var x = new Date();  
            let y = x.getFullYear();
            let m = x.getMonth() + 1;
            m = m < 10 ? '0'+m : m;
            let MonthFirstDate = y + '-' + m + '-' + '01 00:00:00';
            return MonthFirstDate;
        },
        goToDetailPage(row){
            this.$store.commit('menu/setFromPage', 'cardMgt');
            this.$store.commit('menu/setFromPageIccid', row.iccid);
            document.getElementById('cardDetailsMenu').click();
        },
  //导出
        exportConsumption($event) {
            this.$confirm("您确定要导出SIM卡列表吗？", "提示" ,{          
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then( () => {
            common.resetCurrentPage(this, $event, 'tbpg');
            var data = common.getRequestParams(this, 'tbpg', this.searchForm);
               if(data.usedFlowRate){
                data.usedFlowRate = data.usedFlowRate * 1024;
                }
                exportConsumptionList(data).then(res =>{
                    if(res.data.code == 200){
                        this.$message.success('数据导出中,请稍候去任务中心下载');
                    }else{
                        this.$message.error(res.data.msg);
                    }
                }).catch(err=>console.error(err)); 
            })
        }

        
    },
    created() {
        common.getBranchSupplierOptionCom(this, 'branchSupplierOption')
        this.getUseDataHanler();
    }
}
</script>

<style>

</style>